<template>
  <div id="bodies">
    <h4><span v-if="selectBook">{{selectBook.title}} > </span>本文の編集</h4>
    <section>
      <el-form label-width="100px" :model="newBody" style="width:100%">
        <el-form-item label="本文の設定">
          <el-input placeholder="本文のタイトル（小見出し）" v-model="newBody.title"></el-input>
        </el-form-item>
        <el-form-item label="章の設定">
          <el-select v-model="newBody.chapter" value-key="id">
            <el-option
              :key="0"
              :label="'指定しない'"
              :value="{id:0, title:'指定しない'}">
            </el-option>
            <el-option
              v-for="chapter in $store.state.Chapters.chapters"
              :key="chapter.id"
              :label="chapter.title"
              :value="chapter">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="save(newBody)">追加</el-button>
        </el-form-item>
      </el-form>
    </section>

    <section v-for="(chapter, id) in objArraySort(cloneObject(bodyChapters), 'number', 'asc')" :key="id">

      <h4>{{chapter.title || '章の指定なし'}}</h4>

      <el-table
        :data="chapter.bodies"
        style="width:100%">
        <el-table-column
          label="順序"
          width="100">
          <template slot-scope="scope">
            <el-input v-if="current.body_id === scope.row.body_id" type="number" min="1" v-model="current.sequence" />
            <span v-else>{{scope.row.sequence}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="本文タイトル（小見出し）">
          <template slot-scope="scope">
            <el-input v-if="current.body_id === scope.row.body_id" type="text" v-model="current.title" />
            <span v-else>{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button v-if="current.body_id === scope.row.body_id && !equalObject(current, scope.row)"
              size="mini"
              type="primary"
              @click="save(current)">保存</el-button>
            <el-button v-if="current.body_id === scope.row.body_id && equalObject(current, scope.row)"
              size="mini"
              @click="cancel()">キャンセル</el-button>
            <el-button v-if="current.body_id !== scope.row.body_id"
              size="mini"
              @click="edit(scope.row)">修正</el-button>
          </template>
        </el-table-column>
        <el-table-column
          width="220">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="detail(scope.row)">本文編集</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="remove(scope.row)">削除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'bodies',
  data () {
    return {
      newBody: {
        sequence: 0,
        title: '',
        chapter: {
          id: 0,
          title: '指定しない'
        }
      },
      current: {sequence: 0, title: ''}
    }
  },
  created () {
    console.log('bodies::created')
    console.log(this.$route.params.body_id)
    this.fetchBodies()
    if (this.equalObject(this.$store.state.Chapters.chapters, [])) {
      this.fetchChapters()
    }
  },
  mounted () {
    console.log('bodies::mounted')
  },
  computed: {
    ...mapGetters('Books', ['selectBook']),
    ...mapGetters('Bodies', ['bodyChapters'])
  },
  methods: {
    fetchBodies () {
      this.$store.dispatch('Bodies/fetch', {'book_id': this.$route.params.id})
    },
    fetchChapters () {
      this.$store.dispatch('Chapters/fetch', {'book_id': this.$route.params.id})
    },
    detail (body) {
      this.$router.push('/books/' + this.$route.params.id + '/bodies/' + body.body_id)
    },
    edit (body) {
      this.current = this.cloneObject(body)
    },
    cancel () {
      this.current = {sequence: 0, title: ''}
    },
    save (body) {
      if (body.title === '') {
        this.errorMessage('タイトルが入力されていません')
        return
      }

      var data = {
        id: body.body_id,
        sequence: body.sequence,
        title: body.title
      }

      var action = ''
      if (!body.body_id) {
        action = 'insert'
        data.book_id = this.$route.params.id
        data.chapter_id = body.chapter.id
      } else {
        action = 'update'
        data.chapter_id = body.chapter_id
      }

      var self = this
      this.$store.dispatch('Bodies/' + action, {'body': data}).then(function (response) {
        if (!response.result) {
          self.errorMessage(response.message)
        } else {
          self.fetchBodies()
          self.successMessage(response.message)
          self._clearEditor()
        }
      }).catch(function (error) {
        self.errorMessage(error.message)
        self._clearEditor()
      })
    },
    remove (body) {
      console.log(body)
      this.$confirm('「' + body.title + '」を削除します。よろしいですか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        var self = this
        this.$store.dispatch('Bodies/delete', {'id': body.body_id}).then(function (response) {
          if (!response.result) {
            self.errorMessage(response.message)
          } else {
            self.fetchBodies()
            self.successMessage(response.message)
          }
        })
      }).catch(() => {})
    },
    _clearEditor () {
      this.newBody = {
        sequence: 0,
        title: '',
        chapter: {
          id: 0,
          title: '指定しない'
        }
      }
      this.current = {sequence: 0, title: ''}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/04-pages/Bodies.vue